import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "@/site";

const VALUES = [
    "Local, family-owned business",
    "Professional workmanship on every job",
    "Honest communication — no surprises",
    "Respect for you and your property",
    "Dependable service, day and night",
];

export const About = () => (
    <section id="about" data-testid="about-section" className="bg-white py-20 sm:py-24 lg:py-28">
        <div className="mx-auto grid w-full max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
            <Reveal className="relative">
                <div className="absolute -left-4 -top-4 h-full w-full rounded-3xl border-2 border-gold/40" aria-hidden="true" />
                <img
                    src={IMAGES.about}
                    alt="Locksmith technician at work with professional tools"
                    loading="lazy"
                    className="relative h-[380px] w-full rounded-3xl object-cover shadow-2xl shadow-navy-950/20 sm:h-[460px]"
                />
            </Reveal>
            <div>
                <Reveal>
                    <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.28em] text-gold-dark">
                        <span className="h-px w-8 bg-gold-dark" />
                        About Us
                    </p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 data-testid="about-heading" className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-slate-900 sm:text-4xl lg:text-[2.75rem]">
                        Professional Locksmith Service With a <span className="italic text-gold-dark">Personal Approach</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-5 text-base leading-relaxed text-slate-600">
                        Regina Expert Locksmith is a family-owned local business serving Regina and the surrounding
                        Saskatchewan communities. We built this company on a simple idea: when someone calls a
                        locksmith, they're often having a stressful day — and they deserve someone who shows up, does
                        the work properly, and treats them fairly.
                    </p>
                    <p className="mt-4 text-base leading-relaxed text-slate-600">
                        We won't claim to be the biggest or the cheapest. What we promise is professional workmanship,
                        honest communication, respect for your property, and dependable service whenever you need it —
                        including the middle of the night.
                    </p>
                </Reveal>
                <Reveal delay={0.24}>
                    <ul data-testid="about-values" className="mt-7 space-y-3">
                        {VALUES.map((v) => (
                            <li key={v} className="flex items-start gap-3 text-sm font-semibold text-slate-800">
                                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold/15 text-gold-dark">
                                    <Check className="h-3 w-3" />
                                </span>
                                {v}
                            </li>
                        ))}
                    </ul>
                </Reveal>
            </div>
        </div>
    </section>
);
